import React from 'react';
import styled from '@emotion/styled';
import { PropTypes } from '../lib/imports';
import { stylingHelpers } from '../designTokens';
import Heading from '../components/chrome/Heading';
import Button from '../components/chrome/Button';
import Text from '../components/chrome/Text';

const { fixAll, flexStack, flexCenter } = stylingHelpers;

const Container = styled.div`
  ${fixAll()}
  ${flexCenter()}
  z-index: ${({ theme }) => theme.zIndex.modal};
  padding: 0 24px;
  touch-action: none;
  -webkit-overflow-scrolling: touch;
`;

const Backdrop = styled.div`
  ${fixAll()}
  padding: 0 24px;
  background-color: ${({ theme }) => theme.colors.b400};
  opacity: 0.66;
`;

const Wrapper = styled.div`
  ${flexStack()}
  background: ${({ theme }) => theme.colors.n300};
  z-index: ${({ theme }) => theme.zIndex.modalbox};
  border-radius: ${({ theme }) => theme.borderRadius.peta};
  width: 100%;
  max-width: 375px;
  padding: ${({ theme }) => theme.spacings.giga};
`;

const ModalPrimary = styled.div`
  ${flexStack()}
  width: 100%;
`;

const MainHeading = styled(Heading)`
  text-align: center;
  font-size: ${({ theme }) => theme.typography.text.zetta.fontSize};
  font-weight: bold;
  margin: 0 0 ${({ theme }) => theme.spacings.mega};
`;

const BodyText = styled(Text)`
  text-align: center;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.b100};
  line-height: 18px;
  margin-bottom: ${({ theme }) => theme.spacings.giga};
`;

const ButtonContainer = styled.div`
  ${flexStack()}
  width: 100%;
  gap: 12px;
`;

const LeaveButton = styled(Button)`
  width: 100%;
  background: ${({ theme }) => theme.colors.r500};
  border: none;
  color: ${({ theme }) => theme.colors.n300};
  border-radius: ${({ theme }) => theme.borderRadius.giga};
  padding: ${({ theme }) => theme.spacings.kilo} ${({ theme }) => theme.spacings.mega};
  font-weight: ${({ theme }) => theme.fontStack.bold.weight};
`;

const CancelButton = styled(Button)`
  width: 100%;
  background: transparent;
  border: 2px solid ${({ theme }) => theme.colors.b200};
  color: ${({ theme }) => theme.colors.b400};
  border-radius: ${({ theme }) => theme.borderRadius.giga};
  padding: ${({ theme }) => theme.spacings.kilo} ${({ theme }) => theme.spacings.mega};
  font-weight: ${({ theme }) => theme.fontStack.bold.weight};
`;

const IncompletePicksModal = ({
  title,
  text,
  leaveButtonText,
  cancelButtonText,
  onLeave,
  onCancel,
  leaveAriaLabel,
  cancelAriaLabel,
}) => (
  <Container onClick={onCancel}>
    <Backdrop />
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <ModalPrimary>
        <MainHeading noMarginBottom>{title}</MainHeading>
        <BodyText noMargin>{text}</BodyText>
        <ButtonContainer>
          <LeaveButton variant='primary' aria-label={leaveAriaLabel} onSelect={onLeave}>
            {leaveButtonText}
          </LeaveButton>
          <CancelButton variant='secondary' aria-label={cancelAriaLabel} onSelect={onCancel}>
            {cancelButtonText}
          </CancelButton>
        </ButtonContainer>
      </ModalPrimary>
    </Wrapper>
  </Container>
);

IncompletePicksModal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  leaveButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onLeave: PropTypes.func,
  onCancel: PropTypes.func,
  leaveAriaLabel: PropTypes.string,
  cancelAriaLabel: PropTypes.string,
};

export default IncompletePicksModal;
